import "vidstack/player/styles/default/poster.css";
import {
defineCustomElement,
MediaPosterElement,
MediaPlyrLayoutElement
} from "vidstack/elements";

defineCustomElement(MediaPosterElement);
defineCustomElement(MediaPlyrLayoutElement);